import { useHotkeys } from 'react-hotkeys-hook';
import { usePostHog } from 'posthog-js/react';
import {useNavigate} from "react-router-dom";
import {useCurrentHotel} from "../providers/CurrentHotelProvider.jsx";

export const useTrackedHotkeys = (keys, callback, action, options) => {
  const posthog = usePostHog();
  const navigate = useNavigate();
  const {linkTo} = useCurrentHotel()

  return useHotkeys(
    keys,
    (event) => {
      if (callback && typeof callback === 'string') {
        posthog.capture('hotkey_triggered', {
          keys,
          action: 'goto:'+callback,
        });

        navigate(linkTo(callback))
      } else {
        posthog.capture('hotkey_triggered', {
          keys,
          action: action || 'unknown',
        });

        callback(event);
      }
    },
    options
  );
};
